import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import './driver-theme.css';
import type { TourDef } from './tours';
import type { Dictionary } from '../i18n';

/**
 * Run a tour with driver.js. Steps whose `data-tour` anchor is not present in
 * the DOM are skipped (a feature gated off, an item that doesn't exist yet, or
 * a panel that's collapsed), so a tour gracefully adapts to what the user can
 * actually see. `onEnd` fires once the tour finishes, is skipped, or is closed.
 */
export function runTour(tour: TourDef, t: Dictionary, onEnd: () => void): void {
  const steps = tour.steps
    .filter(
      (s) => s.anchor === '' || !!document.querySelector(`[data-tour="${s.anchor}"]`),
    )
    .map((s) => ({
      element: s.anchor ? `[data-tour="${s.anchor}"]` : undefined,
      popover: {
        title: s.title,
        description: s.body,
        side: s.side,
        align: s.align,
      },
    }));

  if (steps.length === 0) {
    onEnd();
    return;
  }

  const c = t.onboarding.controls;
  let ended = false;
  const end = () => {
    if (ended) return;
    ended = true;
    onEnd();
  };

  const instance = driver({
    showProgress: steps.length > 1,
    allowClose: true,
    overlayOpacity: 0.6,
    nextBtnText: c.next,
    prevBtnText: c.back,
    doneBtnText: c.done,
    steps,
    onDestroyed: () => end(),
  });

  instance.drive();
}
